import React from 'react';
import { HomePage } from 'shared-home/src/home/HomePage';

export function HomePageWrapper() {
  return <HomePage configPath={'/configurator/'} preloadSestav={true} showPrice={false} />;
}
